import { da } from 'date-fns/locale';
import { forwardRef, useEffect, useRef, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { DatePickerCustomHeader, DatePickerCustomHeaderProps } from './DatePickerCustomHeader/DatePickerCustomHeader';
import { DatePickerInput } from './DatePickerInput/DatePickerInput';
import './ReactDatePicker.css';
export interface DatePickerProps
	extends Omit<
		React.ComponentProps<ReactDatePicker>,
		'className' &
			'id' &
			'selected' &
			'renderCustomHeader' &
			'customInput' &
			'onChangeRaw' &
			'onChange' &
			'locale' &
			'dateFormat' &
			'placeholderText' &
			'required' &
			'disabled'
	> {
	callBack?: (selectedDate: Date) => void;
	language?: 'da';
	id: string;
	name?: string;
	className?: string;
	defaultDate?: Date;
	placeholder?: string;
	ariaLabels: DatePickerCustomHeaderProps['ariaLabels'];
	enableMonthSelect?: boolean;
	enableYearSelect?: boolean;
	yearOptions?: DatePickerCustomHeaderProps['yearOptions'];
	error?: string;
	required?: boolean;
	disabled?: boolean;
	triggerResetInput?: number;
}

// TODO it's a cascading job to remove this any, i'll (oscar) take a look at it
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CustomInput = forwardRef(function CustomInput(props: any, customRef) {
	return <DatePickerInput {...props} innerRef={customRef} />;
});

export const DatePicker: React.FC<DatePickerProps> = ({
	callBack,
	language = 'da',
	id,
	name,
	className,
	defaultDate,
	placeholder,
	ariaLabels,
	enableMonthSelect = false,
	enableYearSelect = false,
	yearOptions,
	error,
	required,
	disabled,
	triggerResetInput,
	...props
}) => {
	const [selectedDate, setSelectedDate] = useState<Date | null>(defaultDate);
	const inputRef = useRef(null);
	const handleChangeRaw = (date) => {
		const newRaw = new Date(date.currentTarget.value);
		if (newRaw instanceof Date && !isNaN(newRaw.getTime())) {
			setSelectedDate(newRaw);
		}
	};

	useEffect(() => {
		setSelectedDate(defaultDate);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [triggerResetInput]);

	return (
		<div className={className}>
			<ReactDatePicker
				id={id}
				name={name}
				selected={selectedDate}
				renderCustomHeader={(headerProps) => (
					<DatePickerCustomHeader
						{...headerProps}
						locale={language}
						ariaLabels={ariaLabels}
						enableMonthSelect={enableMonthSelect}
						enableYearSelect={enableYearSelect}
						yearOptions={yearOptions}
					/>
				)}
				customInput={<CustomInput error={error} customRef={inputRef} />}
				onChangeRaw={(e) => handleChangeRaw(e)}
				onChange={(date: Date | null) => {
					setSelectedDate(date);
					callBack && callBack(date);
				}}
				locale={language === 'da' ? da : null}
				dateFormat="dd/MM/yyyy"
				placeholderText={placeholder}
				required={required}
				disabled={disabled}
				{...props}
			/>
		</div>
	);
};
